import { useMemo } from "react";
import { ContentRendererContainer } from "./ContentRendererContainer";
import { PropertyPhoto } from "../property/PropertyPhoto";
import type { StaticPagesImageGalleryComponent } from "../../../api/content-client/service";

export function ContentRendererImageGallery(block: StaticPagesImageGalleryComponent) {
  const {
    containerProps,
    media,
  } = block || {};

  const computedThumbs = useMemo(() => {
    if (!media?.data || !Array.isArray(media?.data)) {
      return [{ src: '' }];
    }

    return media.data.map(el => ({
      src: el.attributes?.url ?? '',
      title: el.attributes?.alternativeText,
    }));
  }, [media?.data]);

  return (
    <ContentRendererContainer containerProps={containerProps}>
      <PropertyPhoto hasNoImgProxy thumbs={computedThumbs} />
    </ContentRendererContainer>
  )
}
